import React from "react";
import PropTypes from "prop-types";
import { Tabs } from "@mantine/core";
import { IconChevronDown, IconChevronUp } from "@tabler/icons-react";

class CenteredTabs extends React.Component {
	state = {
		value: 0,
		hidden: false,
	};

	handleChange = (value) => {
		if (value === "__toggle__") return;
		const numValue = parseInt(value, 10);
		this.setState({ value: numValue }, () => {
			this.props.switchedTab && this.props.switchedTab(numValue);
		});
	};
	toggleHide = () => {
		this.setState({ hidden: !this.state.hidden }, () => {
			this.props.toggleHide && this.props.toggleHide();
		});
	};
	static getDerivedStateFromProps(props) {
		const newState = { value: props.activeTab || 0, hidden: props.hidden };
		return newState;
	}
	render() {
		const leftSideTabs = this.props.tabs.filter((t) => !t.rightJustified);
		const rightSideTabs = this.props.tabs.filter((t) => t.rightJustified);
		if (this.props.toggleHide) {
			rightSideTabs.push({
				label: this.state.hidden ? (
					<IconChevronDown size={24} />
				) : (
					<IconChevronUp size={24} />
				),
				rightJustified: true,
				onClick: (e) => {
					e.stopPropagation();
					this.toggleHide();
				},
				"aria-label": "toggle",
				value: "__toggle__",
			});
		}
		return (
			<div
				style={{
					backgroundColor: "var(--lw-light-grey-a)",
				}}
			>
				<Tabs
					value={String(this.state.value)}
					onChange={this.handleChange}
					color="lxw-blue"
				>
					<Tabs.List style={{ width: "100%" }}>
						{leftSideTabs.map((item, i) => (
							<Tabs.Tab
								value={String(i)}
								key={"Tab_Left_" + i}
								style={
									item.rightAlign
										? { marginLeft: "auto" }
										: undefined
								}
							>
								{item.label}
							</Tabs.Tab>
						))}
						{rightSideTabs.map((item, i) => {
							// eslint-disable-next-line
							const { hoverTitle, rightJustified, ...rest } =
								item;
							return (
								<Tabs.Tab
									title={hoverTitle}
									value={String(leftSideTabs.length + i)}
									key={
										"Tab_Right_" + (leftSideTabs.length + i)
									}
									style={
										i === 0
											? {
													marginLeft: "auto",
													borderLeft:
														"1px solid var(--lw-medium-grey)",
													borderTop:
														"1px solid var(--lw-medium-grey)",
													borderRadius: "0",
												}
											: {
													borderLeft:
														"1px solid var(--lw-medium-grey)",
													borderTop:
														"1px solid var(--lw-medium-grey)",
													borderRadius: "0",
												}
									}
									{...rest}
								>
									{item.label}
								</Tabs.Tab>
							);
						})}
					</Tabs.List>
				</Tabs>
			</div>
		);
	}
}

CenteredTabs.propTypes = {
	tabs: PropTypes.array.isRequired,
};

export default CenteredTabs;
